"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SongOfMidnightAbilityHandler = exports.SongOfMidnightActorAbilityFactory = exports.SongOfMidnightAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class SongOfMidnightAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SongOfMidnight;
        this.__typeName = "SongOfMidnight";
    }
}
exports.SongOfMidnightAbilityArgs = SongOfMidnightAbilityArgs;
let SongOfMidnightActorAbilityFactory = class SongOfMidnightActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SongOfMidnight", "AllEnemies", 4);
    }
};
SongOfMidnightActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SongOfMidnight")
], SongOfMidnightActorAbilityFactory);
exports.SongOfMidnightActorAbilityFactory = SongOfMidnightActorAbilityFactory;
let SongOfMidnightAbilityHandler = class SongOfMidnightAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId: targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 90)
                ],
            })),
            onHit: (sequence, { targetId }) => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(5),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.NatureDamageImmunity, 2),
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.PhysicalDamageImmunity, 2)
                    ], true),
                    onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest", "front"), 
                    // TODO: replace with a better vfx
                    "BloodyClaws", false))
                });
                const randomTargetId = (0, Random_1.randomElement)(container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies));
                container.removeRandombuff({
                    sequence,
                    removerId: ability.invokerId,
                    targets: [{
                            count: 1,
                            targetId: randomTargetId,
                            onBuffRemoved: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest", "front"), 
                            // TODO: replace with a better vfx
                            "DarkLightning", false))
                        }],
                });
            },
        });
    }
};
SongOfMidnightAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SongOfMidnight)
], SongOfMidnightAbilityHandler);
exports.SongOfMidnightAbilityHandler = SongOfMidnightAbilityHandler;
